import CacheCleaner from "./CacheCleaner"
import HorseCleaner from "./HorseCleaner"

export default class HorsePensionCleaner extends CacheCleaner {
	async onMutation(horse_ids) {
		await HorseCleaner.inst().onMutation(horse_ids, ['horse_actual_pension'])
	}
}
